<template>
  <div class="salaryreports__report__view">
    <div class="reports__subheader">
      <year-month-panel @year="(value) => setYear(value)" @month="(value) => setMonth(value)" :label="'Fra Måned, År'" v-if="!showToDate"> </year-month-panel>

      <div class="schedule__daynavigator">
        <day-select-dropdown :selectedDate="getFromDate" @date-selected="(value) => setDate(value, 0)" mode="day" v-if="showToDate">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a tooltiptext tabindex="0" class="this-week-button test-this-week control-button" @click="toggleDropdown">
              <span class>
                <span class="control-button-text">{{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
      </div>

      <div class="schedule__daynavigator">
        <day-select-dropdown :selectedDate="getToDate" @date-selected="(value) => setDate(value, 1)" mode="day" v-if="showToDate">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a tooltiptext tabindex="0" class="this-week-button test-this-week control-button" @click="toggleDropdown">
              <span class>
                <span class="control-button-text">{{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
      </div>

      <submit-panel @submit="performLookupTotal" class="no-print"> </submit-panel>

      <b-dropdown aria-role="list" style="margin-top: 20px;margin-left: 20px;float:right;">
        <template #trigger="{ active }">
          <b-button style="height: 28px !important;" label="Handlinger" type="is-primary" :icon-right="active ? '' : ''" />
        </template>

        <b-dropdown-item aria-role="listitem" @click="() => { setShowYearTotal(!showYear); }" v-bind:style="showYear ? 'background: darkgray;' : ''">Vis års rapport</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { modelUpdated(); setCompareDate(!compareDate); }"  v-bind:style="compareDate ? 'background: darkgray;' : ''">Vis sammenligning (forrige år)</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { modelUpdated(); setShowToDate(!showToDate); }" v-bind:style="showToDate ? 'background: darkgray;' : ''" v-if="isAdmin">Vis dato vælger</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { exportCsv(); }" v-if="isAdmin">Eksport</b-dropdown-item>
      </b-dropdown>

      <div class="reports__panel--submit" v-if="showPanel === true && salaryReportList && salaryReportList.mergedRows && salaryReportList.mergedRows.length > 0">
        <b-button class="button is-primary" @click="setFilterSalary()">
          Filtrere Løn
        </b-button>
      </div>

      <!-- <div class="reports__panel--submit" v-if="showPanel === true && salaryReportList && salaryReportList.mergedRows && salaryReportList.mergedRows.length > 0">
        <b-button class="button is-primary" @click="setFilterEmployee()">
          Filtrere medarbejdere
        </b-button>
      </div> -->
    </div>

    <template>
      <div class="wrapper">
        <h2>
          Lønrapport
        </h2>
        <div style="text-align: left; margin-left: 0px;border-bottom: 1px solid darkgray;margin-top: 20px; height: 35px;">
          <h3 class="inline font-bold">
            HandyVik
          </h3>
          <b-button v-if="canEdit" type="is-primary" class="inline" style="float:right;  padding:0px 5px" @click="addNewLine('partialSumRows')">
            + linje
          </b-button>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.partialSumRows">
          <tbody v-for="row in salaryReportList.partialSumRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || (row.total && row.total !== 0)) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
                <input v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.reportRowName" />
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ (row.isMinutes && row.minutes ? row.minutes : row.times) | salarydecimal }}</span>
                <input v-if="canEdit" style="max-width:80px" v-model="row.times" type="number" />
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
                <select v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.type" style="border-radius: 0px; border: 2px solid; height: 25px;">
                  <option value="gange">gange</option>
                  <option value="min.">min.</option>
                  <option value="dag(e)">dag(e)</option>
                </select>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
                <input style="max-width:80px" v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit">{{ row.total | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.total && row.total !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | salarydecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.total && row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left;width:400px;">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right; width: 55px;"></td>
              <td style="text-align: right;" class="AVG">{{ row.total | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Øvrige
          </h3>
          <b-button v-if="canEdit" type="is-blue" class="inline" style="float:right; padding:0px 5px" @click="addNewLine('payrollRows')">
            + linje
          </b-button>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.payrollRows">
          <tbody v-for="row in salaryReportList.payrollRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || (row.total && row.total !== 0)) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <div v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">
                  <span v-if="!row.link">{{ row.reportRowName }} </span>
                  <a v-if="row.link" target="_blank" v-bind:href="row.link" title="Klik her for at se hvor data kommer fra">{{ row.reportRowName }}</a>
                </div>
                <input v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.reportRowName" />
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ (row.isMinutes && row.minutes ? row.minutes : row.times) | salarydecimal }}</span>
                <input style="max-width:80px" v-model="row.times" type="number" v-if="canEdit" />
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
                <select v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.type" style="border-radius: 0px; border: 2px solid; height: 25px;">
                  <option value="gange">gange</option>
                  <option value="min.">min.</option>
                  <option value="dag(e)">dag(e)</option>
                </select>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }} </span>
                <input style="max-width:80px" v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;" v-bind:class="row.calculateGroup">
                <span v-if="isAdmin === false || false === canEdit">{{ row.total | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.total && row.total !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | salarydecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.total && row.total > 0 && row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left;width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.total | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Diverse
          </h3>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.general">
          <tbody v-for="row in salaryReportList.general" :value="row.value" :key="row.value">
            <tr v-show="row.newLine || ((showEmpty || row.times !== 0) && row.identifier !== 'Total') && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ row.isMinutes && row.minutes ? row.minutes : row.times | salarydecimal }} </span>
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit">{{ row.total | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.times !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | nodecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.total | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Samlet
          </h3>
        </div>
        <table style="width: 100%;" class="total-rows" v-if="salaryReportList.totalSalaryRows">
          <tbody v-for="row in salaryReportList.totalSalaryRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.total > 0) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px">
                {{ row.reportRowName }}
              </td>
              <td v-show="compareDate"></td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span>{{ row.hoursPrSession | salarydecimal }}</span>
              </td>
              <td style="text-align: left; width: 55px;">{{ row.type }}</td>
              <td style="text-align: right; width: 55px;">
                <span v-if="specialAllowanceCanBeEdited(row.reportRowName) === false">{{ row.rate | salarydecimal }}</span>
                <input style="max-width:80px" v-if="specialAllowanceCanBeEdited(row.reportRowName)" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;">
                <span v-if="!row.rate || row.rate === 0 || isAdmin === false || false === canEdit">{{ row.total | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.total | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div style="text-align: left; margin-left: 0px;border-bottom: 1px solid darkgray;margin-top: 20px; height: 35px;">
          <h3 class="inline font-bold">
            Aconto
          </h3>
        </div>
        <table style="width: 100%;background-color: white;" v-if="salaryReportList.onAccountSalaryRows">
          <tbody v-for="row in salaryReportList.onAccountSalaryRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || row.total !== 0) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                {{ row.hoursPrSession | salarydecimal }}
              </td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit || !row.isUserDefined">{{ row.total | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.total | salarydecimal }} DKK</td>
            </tr>
          </tbody>
        </table>

        <h3 style="text-align: left; margin-left: 0px;font-weight: bold;border-bottom: 1px solid darkgray;margin-top: 25px;">
          Gennemsnitlig
        </h3>
        <table style="width: 100%;background-color: lightgray;" v-if="salaryReportList.averageRows">
          <tbody v-for="row in salaryReportList.averageRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.times > 0) && row.identifier !== 'Total' && row.isSelected" v-bind:title="row.toolTip">
              <td class="row-name" style="text-align: left;width:400px">{{ row.reportRowName }}</td>
              <td style="text-align: right; width: 55px;padding: 0px 5px" v-bind:style="{ background: row.timesBackground }">
                <span v-if="isAdmin === false || false === canEdit">{{ row.isMinutes && row.minutes ? row.minutes : row.times | nodecimal }} </span>
              </td>
              <td style="text-align: left; width: 55px;" v-bind:style="{ background: row.timesBackground }">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="text-align: right;" v-bind:class="row.calculateGroup">{{ row.rate | salarydecimal }}</td>
              <td style="text-align: right;"></td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.total | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </template>
    <csv-modal></csv-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import APISTATE from "@/enums/APISTATE";
  import YearMonthPanel from "@/components/report/YearMonthPanel.vue";
  import SubmitPanel from "@/components/report/SubmitPanel.vue";
  import CsvModal from "@/components/common/CsvModal.vue";
  import DaySelectDropdown from "@/components/common/DaySelectDropdown.vue";
  import moment from "moment";
import { set } from "lodash";

  export default {
    name: "salary-report-view",
    components: {
      YearMonthPanel,
      /* EmployeesPanel, */
      /*       SalaryTypePanel, */
      SubmitPanel,
      CsvModal,
      DaySelectDropdown,
    },
    data: () => ({
      saving: false,
      salaryTypeId: undefined,
      selectedSalaryTypes: [],
      selectedEmployees: [],
      showPanel: true,
      n: 0,
      salaryGroups: [],
    }),
    async mounted() {
      this.initYearMonth();
      this.setFromDate(new Date());
      this.setToDate(new Date());
      const number = this.currentUser.number.toString();
      console.log(this.currentUser.isSalaryReportOpen);
      console.log(this.currentUser);
      if (number === "1010" || number === "1011") {
        //alert('Løn rapport preview');
      } else {
        this.$router.push("/reports");
      }
    },
    methods: {
      ...mapActions("salaryReportStore", ["processReportSalaryTotal", "setShowFilterEmployee", "lockReportSalaryEmployee", "unlockReportSalaryEmployee", "updateReportSalaryEmployee", "initYearMonth", "setMonth", "setYear", "setToMonth", "setToYear", "setEmployeeNumber", "addNewLine", "performLookupTotal", "setShowYearTotal", "setCompareDate", "setShowEmpty", "setShowToDate", "setFromDate", "setToDate", "exportSalaryReportCsv"]),
      ...mapActions("csvModalStore", ["setModalOpen"]),
      ...mapActions("reportStore", [
        "getGeneralReportForPeriod",
        "setGeneralReportForPeriod",
      ]),
      ...mapActions("generalStatisticsFilteringSidebar", [
        "sidebarOpenAsync",
        "setIsOpen",
        "setGroupMembers",
        "setFilter",
      ]),
      ...mapActions("salaryTypeFilteringSidebar", [
        "salarySidebarOpenAsync",
        "setSalaryIsOpen",
        "setSalaryTypes",
        "setSalaryFilter",
      ]),
      async setFilterEmployee() {
        // TODO this.selectedEmployees.push('TESTER');
        this.setGroupMembers(this.generalReportForPeriod);
        await this.sidebarOpenAsync()
          .then(async (response) => {
            if (response.action === "update") {
              await this.setGeneralReportForPeriod(response.markedGroupMembers);
            }
          })
          .catch((error) => console.error(error));
      },
      async setFilterSalary () {
        console.log(this.salaryReportList.mergedRows);
        this.setSalaryTypes(this.salaryReportList.mergedRows);
        await this.salarySidebarOpenAsync()
          .then(async (response) => {
            if (response.action === "update") {
              if(response.markedSalaryTypes && response.markedSalaryTypes.length > 0) {
                this.salaryReportList.partialSumRows.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
                this.salaryReportList.payrollRows.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
                this.salaryReportList.general.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
                this.salaryReportList.totalSalaryRows.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
                this.salaryReportList.onAccountSalaryRows.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
                this.salaryReportList.averageRows.forEach((agm) => {
                  agm.isSelected = response.markedSalaryTypes.filter(o => o.reportRowName == agm.reportRowName).length > 0;
                });
              }
            }
          })
          .catch((error) => console.error(error));
      },
      getDateFromMonthYear(day, month, year) {
        let date = new Date();
        date.setMonth(month);
        date.setFullYear(year);
        date.setDate(day);
        return date;
      },
      getLatestDayOfMonth(month, year) {
        return new Date(year, month + 1, 0).getDate();
      },
      testDate() {
        return {
          fromDate: this.getDateFromMonthYear(1, 11, 2021),
          toDate: this.getDateFromMonthYear(this.getLatestDayOfMonth(11, 2021), 11, 2021),
        };
      },
      async modelUpdated() {
        await this.performLookupTotal();
      },
      async updateEmployeeData() {
        this.salaryReportList.isYear = this.showYear;
        await this.updateReportSalaryEmployee(this.salaryReportList);
        await this.performLookupTotal();
      },
      async processEmployeeData() {
        if (confirm("Du er ved at låse lønrapport så denne ikke henter live data mere. Vil du fortsætte?")) {
          this.saving = true;
          let fromDate = this.getDateFromMonthYear(1, this.salaryReportFilterMonth, this.salaryReportFilterYear);
          let toDate = this.getDateFromMonthYear(this.getLatestDayOfMonth(this.salaryReportFilterMonth, this.salaryReportFilterYear), this.salaryReportFilterMonth, this.salaryReportFilterYear);

          fromDate = this.getDateFromMonthYear(1, 0, this.salaryReportFilterYear);
          toDate = this.getDateFromMonthYear(31, 11, this.salaryReportFilterYear);

          let number = this.salaryReportFilterEmployeeNumber;
          if (!number || number.toString() === "0") {
            number = this.currentUser.number;
          }
          const dto = {
            assistantNumber: number,
            fromDate: fromDate,
            toDate: toDate,
            compareDate: false,
          };
          await this.processReportSalaryEmployee(dto);
          await this.performLookupTotal();
          this.saving = false;
        }
      },
      specialAllowanceCanBeEdited(reportRowName) {
        if (this.canEdit && (reportRowName === "Særlig feriegodtgørelse - 31/5" || reportRowName === "Særlig feriegodtgørelse - 31/8") && (this.salaryReportList.month === 5 || this.salaryReportList.month === 8 || this.showYear)) {
          return true;
        }
      },
      async lockEmployeeData() {
        if (confirm("Du er ved at afslutte lønrapport. Vil du fortsætte?")) {
          this.saving = true;
          let fromDate = this.getDateFromMonthYear(1, this.salaryReportFilterMonth, this.salaryReportFilterYear);
          let toDate = this.getDateFromMonthYear(this.getLatestDayOfMonth(this.salaryReportFilterMonth, this.salaryReportFilterYear), this.salaryReportFilterMonth, this.salaryReportFilterYear);

          fromDate = this.getDateFromMonthYear(1, 0, this.salaryReportFilterYear);
          toDate = this.getDateFromMonthYear(31, 11, this.salaryReportFilterYear);

          let number = this.salaryReportFilterEmployeeNumber;
          if (!number || number.toString() === "0") {
            number = this.currentUser.number;
          }
          const dto = {
            assistantNumber: number,
            fromDate: fromDate,
            toDate: toDate,
            compareDate: false,
          };
          await this.lockReportSalaryEmployee(dto);
          await this.performLookupTotal();
          this.saving = false;
        }
      },
      async exportSalaryCsv() {
        let fromDate = this.getDateFromMonthYear(1, this.salaryReportFilterMonth, this.salaryReportFilterYear);
        await this.exportSalaryReportCsv({ date: fromDate });

        if (this.salaryReportCsv && this.salaryReportCsv.length > 0) {
          const csvData = [];
          this.salaryReportCsv.forEach((element) => {
            csvData.push({
              "Ins.": element.employeeNumber,
              År: element.year,
              Aconto: element.onAccountSalary,
              Beregnet: element.calculatedSalary,
              Supplement: element.supplementSalary,
              "Total Rest": element.restSalary,
              Dagsløn: element.averageDaySalary,
            });
          });

          const blob = new Blob([this.arrayToCsv(csvData)], { type: "text/csv;charset=utf-8" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "salary_report.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      arrayToCsv(data, delimiter = ";") {
        // Opret en header-række baseret på arrayets nøgler
        const header = Object.keys(data[0]).join(delimiter);

        // Opret data-rækker
        const rows = data.map((row) =>
          Object.values(row)
            .map((value) => (typeof value === "string" && value.includes(delimiter) ? `"${value}"` : typeof value === "number" && !isNaN(value) && value.toString().includes(".") ? new Intl.NumberFormat("da-DK").format(value) : value))
            .join(delimiter)
        );

        // Saml header og data-rækker
        return [header, ...rows].join("\n");
      },
      async unlockEmployeeData() {
        if (this.salaryReportList.state == "PROCESSING" ? confirm("Du er ved at anullere lønrapport. Alle data indtastet vil gå fortabt. Vil du fortsætte?") : true) {
          this.saving = true;
          let number = this.salaryReportFilterEmployeeNumber;
          if (!number || number.toString() === "0") {
            number = this.currentUser.number;
          }
          const dto = {
            assistantNumber: number,
            year: this.salaryReportFilterYear,
          };
          await this.unlockReportSalaryEmployee(dto);
          await this.performLookupTotal();
          this.saving = false;
        }
      },
      async navigateInWeeks(numberOfWeeks) {
        // IGNORE
      },
      formatDate(date) {
        return moment(date).format("YYYY-MM-DD");
      },
      setDate(arg, type) {
        if (!arg) {
          return;
        }

        if (type == 0) {
          this.setFromDate(moment(arg).toDate());
        } else {
          this.setToDate(moment(arg).toDate());
        }
      },
      exportCsv() {
        const partialSumRows = [{Navn: 'HandyVik', Antal: '', Rate: '', Total: ''}].concat(this.salaryReportList.partialSumRows.filter(o => o.isSelected && o.total !== 0).map(map =>  {
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        })).concat([{Navn: 'Øvrige', Antal: '', Rate: '', Total: ''}]).concat(this.salaryReportList.payrollRows.filter(o => o.isSelected && o.total !== 0).map(map =>  {
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        })).concat([{Navn: 'Diverse', Antal: '', Rate: '', Total: ''}]).concat(this.salaryReportList.general.filter(o => o.isSelected && o.total !== 0).map(map =>  { // 
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        })).concat([{Navn: 'Samlet', Antal: '', Rate: '', Total: ''}]).concat(this.salaryReportList.totalSalaryRows.filter(o => o.isSelected && o.total !== 0).map(map =>  {
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        })).concat([{Navn: 'Aconto', Antal: '', Rate: '', Total: ''}]).concat(this.salaryReportList.onAccountSalaryRows.filter(o => o.isSelected && o.total !== 0).map(map =>  {
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        })).concat([{Navn: 'Gennemsnitlig', Antal: '', Rate: '', Total: ''}]).concat(this.salaryReportList.averageRows.filter(o => o.isSelected && o.total !== 0).map(map =>  {
          return { 
            Navn: map.reportRowName, 
            Antal: map.isMinutes ? map.minutes.toString().replace('.', ',') : map.times.toString().replace('.', ','), 
            Rate: map.rate.toString().replace('.', ','), 
            Total: map.total.toString().replace('.', ',') 
          }
        }))
        if(partialSumRows.length === 0) {
          return;
        }

        const array = [Object.keys(partialSumRows[0])].concat(partialSumRows);

        const csv = array.map(it => {
          return Object.values(it).join(';');
        }).join('\n');
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const utf8BOM = '\uFEFF';
        const csvFile = new Blob([utf8BOM + csv], { type: 'text/csv;charset=utf-8;' });
        const downloadLink = document.createElement('a');
        downloadLink.download = 'Lønrapport - ' + new Date().toLocaleDateString('da-DK', options) + '.csv';
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    },
    computed: {
      ...mapGetters("salaryReportStore", ["salaryReportFilterEmployeeNumber", "showFilterEmployee", "salaryReportFilterMonth", "salaryReportFilterYear", "salaryReportApiState", "salaryReportList", "showYear", "compareDate", "showEmpty", "showToDate", "fromDate", "toDate", "toDate", "salaryReportCsv"]),
      ...mapGetters(["currentUser", "isAdmin"]),
       ...mapGetters("reportStore", [
        "generalReportForPeriodApiState",
        "generalReportForPeriod",
      ]),
      ...mapGetters("generalStatisticsFilteringSidebar", ["filter"]),
      ...mapGetters("salaryTypeFilteringSidebar", ["filter"]),
      loading() {
        return this.salaryReportApiState === APISTATE.LOADING && this.generalReportForPeriodApiState === APISTATE.LOADING;
      },
      hasData() {
        return this.salaryReportList && this.salaryReportList.totalSalaryRows && this.salaryReportList.totalSalaryRows.length > 0;
      },
      getFromDate() {
        return this.fromDate;
      },
      getToDate() {
        return this.toDate;
      },
      canEdit() {
        return false;
      },
    },
  };
</script>

<style lang="scss">
  a.dropdown-item,
  .dropdown .dropdown-menu .has-link a,
  button.dropdown-item {
    text-align: left;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  .total-rows {
    background-color: hsl(33, 75%, 78%) !important;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  input[type="number"] {
    max-width: 100px;
    border-radius: 5px;
    padding: 2px 3px;
  }

  .salaryreports__report__view {
    background: #d3d3d34a;
  }

  .wrapper {
    max-width: 800px;
    margin: auto 25%;
    background: white;
    padding: 10px;
    height: 80vh;
  }
  td,
  th {
    font-size: 12px;
    height: 28px;
    vertical-align: middle;
  }

  .AVG {
    background: lightblue;
  }

  .AVGEXTRA {
    background: #d6f3d6;
  }

  .schedule__daynavigator {
    top: 18px;
    position: relative;
    .dayselectdropdown {
      .dayselectdropdown__dropdown {
        right: -156px !important;

        .dayselectdropdown__dayspanel {
          box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
        }
      }
    }
  }
  .schedule__daynavigator > .dayselectdropdown > .dayselectdropdown__dropdown {
    right: -156px !important;
  }

  .control-button {
    width: 120px;
    background: #adadad;
    border: 1px solid #bbb;
    border-radius: 3px;
    color: white;
    cursor: pointer;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 29px;
    line-height: 27px;
    text-align: center;
    text-decoration: none;
  }

  @media print {
    .wrapper {
      max-width: 100%;
      margin: auto auto;
    }
    .total-rows {
      background-color: hsl(33, 75%, 78%) !important;
    }

    .no-print {
      display: none;
    }

    .row-name {
      width: 55% !important;
    }
  }
  .table-header-container {
    text-align: left;
    margin-left: 0px;
    font-weight: bold;
    border-bottom: 1px solid darkgray;
    margin-top: 20px;
    height: 35px;
  }

  .inline {
    display: inline-block;
  }

  .font-bold {
    font-weight: bold;
  }
</style>
